import {FC} from "react";
import { IconSVGProps } from './Icon';


export const CancelIcon: FC<IconSVGProps> = ({width = 16, height = 16}) => (
<svg width={`${width}px`} height={`${height}px`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.94279 8.00009L13.6381 12.6954L12.6954 13.6381L8.00009 8.94279L3.30479 13.6381L2.36206 12.6954L7.05739 8.00009L2.36206 3.30479L3.30479 2.36206L8.00009 7.05739L12.6954 2.36206L13.6381 3.30479L8.94279 8.00009Z" fill="#B8BBC7"/>
</svg>
)